import Component from 'components/component'
import { Modal } from 'components/modal'
import { myEventsList } from 'config/routes'
import Cookies from 'js-cookie'
import { DI } from 'modules'
import React from 'react'
import { withRouter } from 'react-router'
import getAcceptedCookies from '../../../../helpers/cookies'

const COOKIE_KEY = 'first_live_interaction'
export class FirstTimeInteractionPopup extends Component {
  state = {
    show: !Cookies.get(COOKIE_KEY),
  }

  string(key) {
    return this.props.common.strings[
      `page.lives.view.first_interaction_popup.${key}`
    ]
  }

  onClose = () => {
    const cookiesList = getAcceptedCookies()
    if (cookiesList && cookiesList.functional) {
      Cookies.set(COOKIE_KEY, true, { expires: 10 * 365 })
    }
    this.setState({ show: false })
  }

  goToMyEvents = () => {
    const cookiesList = getAcceptedCookies()
    if (cookiesList && cookiesList.functional) {
      Cookies.set(COOKIE_KEY, true, { expires: 10 * 365 })
    }
    this.props.history.push(myEventsList.getPath(this.props.common.locale))
  }

  render() {
    if (this.state.show) {
      return (
        <Modal onClose={this.onClose}>
          <div className="popup-tip">
            <span className="popup__title">{this.string('title')}</span>
            <div className="popup__tip">{this.string('body')}</div>
            <div className="popup-buttons">
              <div className="popup-button">
                <button
                  onClick={this.onClose}
                  type="button"
                  className="text-button"
                >
                  {this.string('btn_cancel')}
                </button>
              </div>
              <div className="popup-button">
                <button
                  type="button"
                  onClick={this.goToMyEvents}
                  className="button"
                >
                  {this.string('btn_continue')}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )
    } else {
      return null
    }
  }
}
export default DI()(withRouter(FirstTimeInteractionPopup))
